import React from 'react';

import BudgetGrid from 'scenes/MarketingPlanning/MarketingPlanningWizard/MarketingPlanningPreview/components/BudgetGrid';
import NodesBudget from 'scenes/MarketingPlanning/MarketingPlanningWizard/MarketingPlanningPreview/components/NodesBudget';
import { ValidationErrors } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/Validation';
import { AFFILIATES } from 'scenes/MarketingPlanning/MarketingPlanningWizard/constants';

const PlatformLevel = () => {
  return (
    <React.Fragment>
      <BudgetGrid />
      <ValidationErrors />
      <NodesBudget
        levelName={AFFILIATES}
        withDownloadNode={true}
        withCBudgetEmptyPlaceholder={true}
      />
    </React.Fragment>
  );
};

export default PlatformLevel;
